import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const InstallationPage = () => {
  return (
    <div className="container mx-auto py-8 px-4 md:px-6">
        <h1 className="text-3xl font-bold mb-8">Installation Guide</h1>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Step 1: Prerequisites</CardTitle>
            <CardDescription>Ensure you have the following installed on your system.</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1">
              <li>Node.js (v18.x or higher recommended)</li>
              <li>npm / yarn / pnpm / bun (package manager)</li>
              <li>A modern web browser (Chrome, Firefox, Safari, Edge)</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Step 2: Download or Clone the Repository</CardTitle>
            <CardDescription>Get the source code for the application.</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-2">You can clone the repository using git:</p>
            <pre className="bg-slate-100 dark:bg-slate-800 p-3 rounded-md text-sm overflow-x-auto">
              <code>git clone [repository-url]</code>
            </pre>
            <p className="text-muted-foreground mt-2">Alternatively, download the source code ZIP file and extract it.</p>
          </CardContent>
        </Card>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Step 3: Install Dependencies</CardTitle>
            <CardDescription>Navigate to the project directory and install the necessary packages.</CardDescription>
          </CardHeader>
          <CardContent>
            <pre className="bg-slate-100 dark:bg-slate-800 p-3 rounded-md text-sm overflow-x-auto">
              <code>cd [project-directory]\nnpm install  # or yarn install, pnpm install, bun install</code>
            </pre>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Step 4: Run the Development Server</CardTitle>
            <CardDescription>Start the application locally.</CardDescription>
          </CardHeader>
          <CardContent>
            <pre className="bg-slate-100 dark:bg-slate-800 p-3 rounded-md text-sm overflow-x-auto">
              <code>npm run dev  # or yarn dev, pnpm dev, bun dev</code>
            </pre>
            <p className="text-muted-foreground mt-2">
              The application should now be running, typically at <a href="http://localhost:5173" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">http://localhost:5173</a> (or another port if configured).
            </p>
          </CardContent>
        </Card>
        
    </div>
  );
};

export default InstallationPage;
